import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect } from "react";
import { useGoogleAPI } from "@jti/fe-clients";
import { useStoreLocatorContext } from "../../../../components/StoreLocator";
import { useConfig } from "../../../../providers/useConfig";
import styles from "./StoreLocatorMap.module.scss";
export const StoreLocatorMap = () => {
    const { locationServiceMapProvider } = useConfig();
    const { mapRef, handleInitMap } = useStoreLocatorContext();
    const _google = useGoogleAPI();
    useEffect(() => {
        if (_google && locationServiceMapProvider === "google") {
            handleInitMap();
        }
    }, [_google]);
    return (_jsx("div", { className: styles.mapWrapper, children: _jsx("div", { ref: mapRef, className: styles.map, "data-testid": "storeLocatorMap", id: "storeLocatorMap" }) }));
};
//# sourceMappingURL=StoreLocatorMap.js.map